import { Drawer as AntdDrawer, Flex } from 'antd';
import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants';
import { NeutralColors } from '@/theme';

export const Drawer = styled(AntdDrawer)`
  & .panorama-drawer-header {
    padding: 12px 12px;
  }

  & .panorama-drawer-body,
  & .panorama-drawer-footer {
    padding: 0;
  }
`;

export const FullHeightContainer = styled(Flex)`
  height: 100%;
`;

export const Body = styled(Flex)`
  overflow-y: auto;
  padding: 16px 18px;
  margin-bottom: 60px;

  &:has([data-footer-align='end']) {
    margin-bottom: 0;
  }
`;

export const FooterWrapper = styled(Flex)<{ $align?: 'space-between' | 'end' }>`
  justify-content: ${({ $align }) =>
    $align === 'end' ? 'flex-end' : 'space-between'};
  gap: ${({ $align }) => ($align === 'end' ? '8px' : '0')};
  flex-wrap: ${({ $align }) => ($align === 'end' ? 'wrap' : 'nowrap')};
  width: 100%;
  position: ${({ $align }) => ($align === 'end' ? 'sticky' : 'absolute')};
  bottom: 0;
  z-index: ${({ $align }) => ($align === 'end' ? 1 : 'auto')};
  padding: ${({ $align }) => ($align === 'end' ? '16px' : '12px 20px')};
  margin: ${({ $align }) => ($align === 'end' ? 'auto -18px 0' : '0 -18px')};
  box-shadow: ${({ $align }) =>
    $align === 'end' ? 'none' : '0px -5px 5px 1px rgba(0, 0, 0, 0.07)'};
  background: ${NeutralColors[0]};

  &&[data-footer-align='end'] > .${CSS_PREFIX}-flex {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  &&[data-footer-align='end']
    .${CSS_PREFIX}-btn-color-default.${CSS_PREFIX}-btn-variant-outlined:not(
      :disabled
    ):not(:hover):not(:active) {
    border-color: ${NeutralColors[20]};
    background: ${NeutralColors[0]};
    color: ${NeutralColors[100]};
  }

  &&[data-footer-align='end']
    .${CSS_PREFIX}-btn-color-primary.${CSS_PREFIX}-btn-variant-outlined:disabled {
    border-color: ${NeutralColors[30]};
    background: ${NeutralColors[0]};
    color: ${NeutralColors[30]};
  }

  &&[data-footer-align='end']
    .${CSS_PREFIX}-btn-color-primary.${CSS_PREFIX}-btn-variant-solid:disabled {
    border-color: ${NeutralColors[20]};
    background: ${NeutralColors[20]};
    color: ${NeutralColors[30]};
  }
`;
